import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import { useFormRemoveObjetion } from '../hooks/useFormRemoveObjection';
import DefaultForm from '../DefaultForm';
import CustomOption from 'src/components/ui/CustomOption';

const DefaultFormCRemoveObjection = (props) => {
	const {
		isPlain,
		onSubmit,
		onCancel,
		serverError,
		options,
		fullHeight,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormRemoveObjetion({
		options,
	});

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
		>
			{(formikProps) => {
				const { values } = formikProps;
				return (
					<FormCard
						title="Снять возражение"
						acceptLabel="Снять"
						fullHeight={fullHeight}
						error={serverError}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={values.objection ? formikProps.submitForm : undefined}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCRemoveObjection.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	options: PropTypes.arrayOf(PropTypes.shape(CustomOption.propTypes)),
};

export default DefaultFormCRemoveObjection;
